import { ResponseRateMapper } from '../mapper/ResponseRateMapper';

export const responseRateMapper = new ResponseRateMapper();
